import NavBar from "../components/navbar";
import Footer from "../components/footer";
import React, { useEffect, useState } from "react";
import PocketBase from "pocketbase";

export default function sponsors() {
  const pb = new PocketBase("https://friendsofstandrewsstatepark.org");
  // eslint-disable-next-line react-hooks/rules-of-hooks
  let [sponsorList, setSponsorList] = useState([]);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    (async () => {
      const records = await pb.collection("corporate_donors").getFullList({
        sort: "-created",
      });
      setSponsorList(records);
    })();
  }, []);

  return (
    <div className="content d-flex flex-fill fsa-body-bg">
      <div className="d-flex flex-column flex-fill justify-content-between">
        <NavBar />
        <div className="d-flex flex-column align-items-center px-3 pt-4 pb-5">
          <h1 className="fsa-section-title text-center">Our Sponsors</h1>
          <p className="text-center mb-4" style={{ maxWidth: 620 }}>
            We are grateful to each and every one of our sponsors for their
            generous support of St. Andrews State Park.
          </p>
          <div className="card w-75" style={{ maxWidth: 900 }}>
            <div className="card-header bg-primary text-white">
              <h5
                className="mb-0"
                style={{ color: "white", fontFamily: "inherit" }}
              >
                Sponsors
              </h5>
            </div>
            <div className="card-body d-flex flex-wrap justify-content-center align-items-center gap-4">
              {sponsorList.length > 0 ? (
                sponsorList.map((sponsor, inx) => (
                  <img
                    key={inx}
                    className="m-2"
                    style={{ maxWidth: 160, height: "auto" }}
                    src={pb.files.getUrl(sponsor, sponsor.logo)}
                    alt={sponsor.company_name}
                  />
                ))
              ) : (
                <p className="text-muted fst-italic mb-0">None Found</p>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
